import { Instance, flow, types } from 'mobx-state-tree';
import { FieldState, FormState, Validator } from 'formstate';
import { required } from '../shared/validators/RequiredValidator';
import { validateIf } from '../shared/validators/ValidIf';
import { noDuplicateGovIdValidator } from './validator/NoDuplicateGovIdValidator'; 
import { matchesRegExp } from '../shared/validators/RegularExpressionValidator';
import { EnrollmentRootStore } from '../../root/EnrollmentRootStore';
import { getRootStore } from '../../root/RootStoreUtils';
 

export const GovernmentEntryStore = types
  .model({
    governmentId: types.string
  })
  .actions(self => ({
    updateStoreFromForm(formData: any) {
      self.governmentId = formData.governmentId;
    },
    applyFormat: flow(function* debounceFormat(govId: any) {
      yield new Promise(r => setTimeout(r, 500));
    }),
  }))
  .views(self => ({
    get supportsDisplay(): boolean {
      return true;
    },
    get rootStore(): EnrollmentRootStore {
      return getRootStore(self);
    },
    get reactForm() {
      
      const validators: Validator<any>[] = [];
      validators.push(required());
      if (this.rootStore.moduleStores.governmentIdFormat) {
        validators.push(matchesRegExp(this.rootStore.moduleStores.governmentIdFormat, 'GovernmentId is invalid'))
      }
      validators.push(validateIf(value => value.trim() !== self.governmentId.trim(), noDuplicateGovIdValidator));
     
      return new FormState({
        governmentId: new FieldState(self.governmentId.trim()).validators(...validators),
      });
    },
    getDataToSubmit() {
      const form = this.reactForm;
      const formData = {
        governmentId: form.$.governmentId.value
      };
      self.updateStoreFromForm(formData);
      return formData;
    },
    canProceed() {
      return !this.reactForm.hasError;
    }
  }))
  .actions(self => ({
    validateForm() {
      return self.reactForm.validate();
    }
  }));

export type GovernmentEntryStore = Instance<typeof GovernmentEntryStore>;
